const SA = 'SA';// 超级管理员
const AD = 'AD';// 技术
const AP = 'AP';// 采购
const AS = 'AS';// 销售
const AF = 'AF';// 财务
const AO = 'AO';// 运营
const FT = 'FT';// 外贸总监



export default [
    {
        path: '/spoAdmin',
        component: () => import('@/views/spoAdmin/spoAdmin.vue'),
        meta: {requireAuth: true, roles: [SA, AD]},
        redirect: '/spoAdmin/business',
        children: [
            {
                path: "/spoAdmin/user",
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                meta: {requireAuth: true, roles: [SA, AD]},
                props: (route) => ({currentTab: 'user'}),
                redirect: '/spoAdmin/user/list',
                children: [
                    {
                        path: '/spoAdmin/user/list',
                        component: () => import('@/views/spoAdmin/user/userManagement/userList.vue'),
                        meta: {requireAuth: true, roles: [SA, AD]},
                        props: (route) => ({user: route.query.user}),
                    },
                    {
                        path: '/spoAdmin/user/vipOrderList',
                        component: () => import('@/views/spoAdmin/user/userManagement/vipOrderList.vue'),
                        meta: {requireAuth: true, roles: [SA, AD]},
                        props: (route) => ({user: route.query.user}),
                    },
                    {
                        path: '/spoAdmin/user/manager',
                        component: () => import('@/views/spoAdmin/user/userManagement/managerList.vue'),
                        meta: {requireAuth: true, roles: [SA, AD]},
                    },
                    {
                        path: '/spoAdmin/user/authorityList',
                        component: () => import('@/views/spoAdmin/user/userManagement/userRoles.vue'),
                        meta: {requireAuth: true, roles: [SA, AD]},
                        props: (route) => ({}),
                    },
                ]
            },
            {
                path: "/spoAdmin/personal",
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                meta: {requireAuth: true, roles: [SA, AD, AS, AP, AF, AO]},
                props: (route) => ({currentTab: 'personal'}),
                redirect: '/spoAdmin/personal/employment',
                children: [
                    {
                        path: '/spoAdmin/personal/payroll',
                        component: () => import('@/views/spoAdmin/user/personal/payroll.vue'),
                        meta: {requireAuth: true, roles: [SA, AD, AS, AP, AF, AO]},
                    },
                    {
                        path: '/spoAdmin/personal/employment',
                        component: () => import('@/views/spoAdmin/user/personal/employmentInformation.vue'),
                        meta: {requireAuth: true, roles: [SA, AD, AS, AP, AF, AO]},
                    },
                    {
                        path: '/spoAdmin/personal/attendance',
                        component: () => import('@/views/spoAdmin/user/personal/attendance.vue'),
                        meta: {requireAuth: true, roles: [SA, AD, AS, AP, AF, AO]},
                    }
                ]
            },
            {
                path: "/spoAdmin/user/bill",
                meta: {requireAuth: true, roles: [SA, AD]},
                component: () => import('@/views/spoAdmin/user/bill/billManagement.vue'),
                redirect: '/spoAdmin/user/bill/list',
                children: [
                    {
                        path: '/spoAdmin/user/bill/list',
                        meta: {requireAuth: true, roles: [SA, AD]},
                        component: () => import('@/views/spoAdmin/user/bill/billList.vue'),
                        props: (route) => ({user: route.query.user}),
                    },
                    {
                        path: '/spoAdmin/user/bill/moduleProfit',
                        meta: {requireAuth: true, roles: [SA, AD]},
                        component: () => import('@/views/spoAdmin/user/bill/profitBill.vue')
                    },
                    {
                        path: '/spoAdmin/user/bill/withdrawMethod',
                        meta: {requireAuth: true, roles: [SA, AD]},
                        component: () => import('@/views/spoAdmin/user/bill/withdrawMethod.vue')
                    },
                    {
                        path: '/spoAdmin/user/bill/balanceManagement',
                        meta: {requireAuth: true, roles: [SA, AD]},
                        component: () => import('@/views/spoAdmin/user/bill/balanceManagement.vue')
                    },
                ]
            },
            {
                path: "/spoAdmin/user/securityQuestion",
                meta: {requireAuth: true, roles: [SA, AD]},
                component: () => import('@/views/spoAdmin/user/securityQuestion/securityQuestion.vue'),
                redirect: '/spoAdmin/user/securityQuestion/list',
                children: [
                    {
                        path: '/spoAdmin/user/securityQuestion/list',
                        meta: {requireAuth: true, roles: [SA, AD]},
                        component: () => import('@/views/spoAdmin/user/securityQuestion/securityQuestionList.vue')
                    },
                    {
                        path: '/spoAdmin/user/securityQuestion/group',
                        meta: {requireAuth: true, roles: [SA, AD]},
                        component: () => import('@/views/spoAdmin/user/securityQuestion/securityQuestionGroup.vue')
                    },
                ]
            },
            {
                path: '/spoAdmin/business',
                meta: {requireAuth: true, roles: [SA, AD, AS, AP, AF, AO, FT]},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({currentTab: 'business'}),
                redirect: '/spoAdmin/business/salesChampion',
                children: [
                    {
                        path: '/spoAdmin/business/salesChampion',
                        meta: {requireAuth: true, roles: [SA, AD, AS, AP, AF, AO]},
                        component: () => import('@/views/spoAdmin/business/salesChampion.vue'),
                    },
                    {
                        path: '/spoAdmin/business/purchaseList',
                        meta: {requireAuth: true, roles: [SA, AP, AF, AD]},
                        component: () => import('@/views/spoAdmin/business/purchaseList.vue'),
                    },
                    {
                        path: '/spoAdmin/business/saleList',
                        meta: {requireAuth: true, roles: [SA, AS, AF, AO, FT, AD]},
                        component: () => import('@/views/spoAdmin/business/saleList.vue'),
                        props: (route) => ({id: route.query.id}),
                    },
                    {
                        path: '/spoAdmin/business/returnsAndExchangesList',
                        meta: {requireAuth: true, roles: [SA, AP, AD]},
                        component: () => import('@/views/spoAdmin/business/returnsAndExchangesList.vue'),
                        // props: (route) => ({id: route.query.id}),
                    }
                ]
            },
            {
                path: '/spoAdmin/productMarketing',
                meta: {requireAuth: true, roles: [SA, AS, AF, AO, AD]},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({currentTab: 'productMarketing'}),
                redirect: '/spoAdmin/productMarketing/productMarketing',
                children: [
                    {
                        path: '/spoAdmin/productMarketing/productMarketing',
                        meta: {requireAuth: true, roles: [SA, AS, AO, AD, FT]},
                        component: () => import('@/views/spoAdmin/business/productMarketing.vue'),
                    },
                    {
                        path: '/spoAdmin/productMarketing/speech',
                        meta: {requireAuth: true, roles: [SA, AS, AO, AD]},
                        component: () => import('@/views/spoAdmin/business/speech.vue'),
                    },
                ]
            },
            {
                path: '/spoAdmin/logistics',
                meta: {requireAuth: true, roles: [SA, AD, AS, AF, AP, AO]},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({currentTab: 'logistics'}),
                redirect: '/spoAdmin/logistics/domestic',
                children: [
                    {
                        path: '/spoAdmin/logistics/domestic',
                        meta: {requireAuth: true, roles: [SA, AD, AS, AF, AP, AO]},
                        component: () => import('@/views/spoAdmin/business/logisticsDomestic.vue'),
                        props: (route) => ({number: route.query.number}),
                    },
                    {
                        path: '/spoAdmin/logistics/global',
                        meta: {requireAuth: true, roles: [SA, AD, AS, AF, AP, AO]},
                        component: () => import('@/views/spoAdmin/business/logisticsGlobal.vue'),
                        props: (route) => ({number: route.query.number}),
                    },
                ]
            },
            {
                path: '/spoAdmin/complain',
                meta: {requireAuth: true, roles: [SA, AD, AS, AP, AF, AO]},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({currentTab: 'complain'}),
                redirect: '/spoAdmin/complain/list',
                children: [
                    {
                        path: '/spoAdmin/complain/list',
                        meta: {requireAuth: true, roles: [SA, AD, AS, AP, AF, AO]},
                        component: () => import('@/views/spoAdmin/business/complainList.vue'),
                        // props: (route) => ({customerId: route.query.customerId, customerType: 'private'}),
                    },
                ]

            },
            {
                path: '/spoAdmin/electricitySales',
                meta: {requireAuth: true, roles: []},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({currentTab: 'electricitySales'}),
                redirect: '/spoAdmin/contract/pl',
                children: [
                    {
                        path: '/spoAdmin/contract/pl',
                        meta: {requireAuth: false, roles: []},
                        component: () => import('@/views/spoAdmin/partnership/contract/photovoltaicLeasing.vue'),
                    },
                    {
                        path: '/spoAdmin/electricitySales/order',
                        meta: {requireAuth: true, roles: []},
                        component: () => import('@/views/spoAdmin/business/electricitySales/order.vue'),
                    },
                    {
                        path: '/spoAdmin/electricitySales/info',
                        meta: {requireAuth: true, roles: []},
                        component: () => import('@/views/spoAdmin/business/electricitySales/info.vue'),
                    },
                ]

            },
            {
                path: '/spoAdmin/customer',
                meta: {requireAuth: true, roles: [SA, AS, AD]},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({currentTab: 'customer'}),
                redirect: '/spoAdmin/customer/customerList',
                children: [
                    {
                        path: '/spoAdmin/customer/customerList',
                        meta: {requireAuth: true, roles: [SA, AS, AD]},
                        component: () => import('@/views/spoAdmin/partnership/customer/customerList.vue'),
                        props: (route) => ({
                            customerName: route.query.customerName,
                            username: route.query.username,
                            customerType: 'private'
                        }),
                    },
                    {
                        path: '/spoAdmin/customer/publicCustomerList',
                        meta: {requireAuth: true, roles: [SA, AS, AD]},
                        component: () => import('@/views/spoAdmin/partnership/customer/customerList.vue'),
                        props: (route) => ({customerId: route.query.customerId, customerType: 'public'}),
                    },
                    {
                        path: '/spoAdmin/customer/partnerCustomerList',
                        meta: {requireAuth: true, roles: [SA, AD]},
                        component: () => import('@/views/spoAdmin/partnership/customer/partnerCustomerList.vue'),
                    },
                ]
            },
            {
                path: '/spoAdmin/supplier',
                meta: {requireAuth: true, roles: [SA, AP, AD]},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({currentTab: 'supplier'}),
                redirect: '/spoAdmin/supplier/list',
                children: [
                    {
                        path: '/spoAdmin/supplier/list',
                        meta: {requireAuth: true, roles: [SA, AP, AD]},
                        component: () => import('@/views/spoAdmin/partnership/supplier/supplierList.vue'),
                        props: (route) => ({supplierName: route.query.supplierName}),
                    },
                ]
            },
            {
                path: '/spoAdmin/contract',
                meta: {requireAuth: true, roles: [SA, AS, AP, AD]},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({currentTab: 'contract'}),
                redirect: '/spoAdmin/contract/pi',
                children: [
                    {
                        path: '/spoAdmin/contract/pi',
                        meta: {requireAuth: true, roles: [SA, AS, AD]},
                        component: () => import('@/views/spoAdmin/partnership/contract/invoiceList.vue')
                    },
                    {
                        path: '/spoAdmin/contract/dc',
                        meta: {requireAuth: true, roles: [SA, AS, AD]},
                        component: () => import('@/views/spoAdmin/partnership/contract/saleContractList.vue'),
                    },
                    {
                        path: '/spoAdmin/contract/pc',
                        meta: {requireAuth: true, roles: [SA, AP, AD]},
                        component: () => import('@/views/spoAdmin/partnership/contract/purchaseContractList.vue'),
                    },
                    {
                        path: '/spoAdmin/contract/quotation',
                        meta: {requireAuth: false, roles: [SA, AS, AP, AD]},
                        component: () => import('@/views/spoAdmin/partnership/contract/quotation.vue'),
                    },
                    {
                        path: '/spoAdmin/contract/check',
                        meta: {requireAuth: true, roles: [SA, AS, AP, AD]},
                        component: () => import('@/views/spoAdmin/partnership/contract/invoiceCheck.vue')
                    }
                ]
            },
            {
                path: '/spoAdmin/product',
                meta: {requireAuth: true, roles: [SA, AD, AS, AP, AO]},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({currentTab: 'product'}),
                redirect: '/spoAdmin/product/specificationList',
                children: [
                    {
                        path: '/spoAdmin/product/productsList',
                        meta: {requireAuth: true, roles: [SA, AD, AS, AP, AO]},
                        component: () => import('@/views/spoAdmin/products/productsList')
                    },
                    {
                        path: '/spoAdmin/product/brandList',
                        meta: {requireAuth: true, roles: [SA, AD, AS, AP, AO]},
                        component: () => import('@/views/spoAdmin/products/brandList')
                    },
                    {
                        path: '/spoAdmin/product/specificationList',
                        meta: {requireAuth: true, roles: [SA, AD, AS, AP, AO]},
                        component: () => import('@/views/spoAdmin/products/specificationList.vue')
                    },


                ]
            },
            {
                path: '/spoAdmin/inventory',
                meta: {requireAuth: true, roles: [SA, AD, AS, AP, AF]},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({currentTab: 'inventory'}),
                redirect: '/spoAdmin/inventory/list',
                children: [
                    {
                        path: '/spoAdmin/inventory/list',
                        meta: {requireAuth: true, roles: [SA, AD, AS, AP, AF]},
                        component: () => import('@/views/spoAdmin/products/inventoryList.vue'),
                        props: (route) => ({spec: route.query.spec}),
                    },
                    {
                        path: '/spoAdmin/warehouseList/list',
                        meta: {requireAuth: true, roles: [SA, AD, AS, AP]},
                        component: () => import('@/views/spoAdmin/products/warehouseList.vue'),
                        props: (route) => ({name: route.query.name}),
                    },
                    {
                        path: '/spoAdmin/warehouseList/circulation',
                        meta: {requireAuth: true, roles: [SA, AD, AS, AP]},
                        component: () => import('@/views/spoAdmin/products/circulation.vue'),
                        props: (route) => ({name: route.query.name}),
                    },
                    {
                        path: '/spoAdmin/inventory/productPackage',
                        meta: {requireAuth: true, roles: [SA, AS, AP, AD]},
                        component: () => import('@/views/spoAdmin/products/productPackage.vue'),
                        // props: (route) => ({spec: route.query.spec}),
                    },
                    {
                        path: '/spoAdmin/inventory/suitList',
                        meta: {requireAuth: true, roles: [SA, AS, AD]},
                        component: () => import('@/views/spoAdmin/products/suitList.vue'),
                    }
                ]
            },
            {
                path: '/spoAdmin/production',
                meta: {requireAuth: true, roles: [SA, AD, AP]},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({currentTab: 'production'}),
                redirect: '/spoAdmin/production/list',
                children: [
                    {
                        path: '/spoAdmin/production/list',
                        meta: {requireAuth: true, roles: [SA, AD, AP]},
                        component: () => import('@/views/spoAdmin/products/production.vue'),
                    },
                    {
                        path: '/spoAdmin/production/bomList',
                        meta: {requireAuth: true, roles: [SA, AD, AP]},
                        component: () => import('@/views/spoAdmin/products/bomList.vue')
                    },
                ]
            },
            {
                path: '/spoAdmin/question',
                meta: {requireAuth: true, roles: []},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({currentTab: 'question'}),
                redirect: '/spoAdmin/question/list',
                children: [
                    {
                        path: '/spoAdmin/question/list',
                        meta: {requireAuth: true, roles: []},
                        component: () => import('@/views/spoAdmin/normalQuestion/questionList.vue'),
                    },
                    {
                        path: '/spoAdmin/question/qa',
                        meta: {requireAuth: true, roles: []},
                        component: () => import('@/views/spoAdmin/normalQuestion/QAList.vue'),
                    },
                ]
            },
            {
                path: '/spoAdmin/userMessage',
                meta: {requireAuth: true, roles: []},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({currentTab: 'userMessage'}),
                redirect: '/spoAdmin/userMessage/list',
                children: [
                    {
                        path: '/spoAdmin/userMessage/list',
                        meta: {requireAuth: true, roles: []},
                        component: () => import('@/views/spoAdmin/message/userMessage/userMessageList.vue'),
                    },
                    {
                        path: '/spoAdmin/userMessage/type',
                        meta: {requireAuth: true, roles: []},
                        component: () => import('@/views/spoAdmin/types.vue'),
                        props: (route) => ({questionType: route.query.questionType, types: 'question'}),
                    },
                ]
            },
            {
                path: '/spoAdmin/news',
                meta: {requireAuth: true, roles: []},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({types: 'companyNews', currentTab: 'news'}),
                redirect: '/spoAdmin/news/swiperList',
                children: [
                    {
                        path: '/spoAdmin/news/companyNews',
                        meta: {requireAuth: true, roles: []},
                        component: () => import('@/views/spoAdmin/news/newsList.vue'),
                        props: (route) => ({types: 'companyNews'}),
                    },
                    {
                        path: '/spoAdmin/news/searchingResult',
                        meta: {requireAuth: true, roles: []},
                        component: () => import('@/views/spoAdmin/news/newsList.vue'),
                        props: (route) => ({types: 'searchingResult'}),
                    },
                    {
                        path: '/spoAdmin/news/projectSharing',
                        meta: {requireAuth: true, roles: []},
                        component: () => import('@/views/spoAdmin/news/newsList.vue'),
                        props: (route) => ({types: 'projectSharing'}),
                    },
                    {
                        path: '/spoAdmin/news/productList',
                        meta: {requireAuth: true, roles: []},
                        component: () => import('@/views/spoAdmin/news/productList.vue'),
                    },
                    {
                        path: '/spoAdmin/news/datasheetList',
                        meta: {requireAuth: true, roles: []},
                        component: () => import('@/views/spoAdmin/news/datasheetList.vue'),
                    },
                    {
                        path: '/spoAdmin/news/swiperList',
                        meta: {requireAuth: true, roles: []},
                        component: () => import('@/views/spoAdmin/news/swiperList.vue'),
                    },
                ]
            },
            // {
            //     path: '/spoAdmin/shopping/main',
            //     meta: {requireAuth: true, roles: [SA]},
            //     component: () => import(/* webpackChunkName: "admin-shopping" */ '@/views/spoAdmin/shopping/shoppingMainPage.vue'),
            // },
            // {
            //     path: '/spoAdmin/shopping/goods',
            //     meta: {requireAuth: true, roles: [SA]},
            //     component: () => import(/* webpackChunkName: "admin-shopping" */ '@/views/spoAdmin/shopping/productDetail/product.vue'),
            //     redirect: '/spoAdmin/shopping/goods/list',
            //     children: [
            //         {
            //             path: '/spoAdmin/shopping/goods/list',
            //             meta: {requireAuth: true, roles: [SA]},
            //             component: () => import(/* webpackChunkName: "admin-shopping" */ '@/views/spoAdmin/shopping/productDetail/productList.vue'),
            //         },
            //         {
            //             path: '/spoAdmin/shopping/goods/type',
            //             meta: {requireAuth: true, roles: [SA]},
            //             component: () => import(/* webpackChunkName: "admin-shopping" */ '@/views/spoAdmin/shopping/productDetail/goodsType.vue'),
            //         },
            //         {
            //             path: '/spoAdmin/shopping/goods/specification',
            //             meta: {requireAuth: true, roles: [SA]},
            //             component: () => import(/* webpackChunkName: "admin-shopping" */ '@/views/spoAdmin/shopping/productDetail/specification.vue'),
            //             props: (route) => ({goodsId: route.query.goodsId}),
            //         },
            //         {
            //             path: '/spoAdmin/shopping/goods/discounts',
            //             meta: {requireAuth: true, roles: [SA]},
            //             component: () => import(/* webpackChunkName: "admin-accessories" */ '@/views/spoAdmin/shopping/productDetail/discounts.vue'),
            //             props: (route) => ({discountsType: route.query.discountsType}),
            //         },
            //         {
            //             path: '/spoAdmin/shopping/goods/images',
            //             meta: {requireAuth: true, roles: [SA]},
            //             component: () => import(/* webpackChunkName: "admin-shopping" */ '@/views/spoAdmin/shopping/productDetail/imageGoods.vue'),
            //             props: (route) => ({cmsId: route.query.cmsId}),
            //         },
            //     ]
            // },
            // {
            //     path: '/spoAdmin/shopping/order',
            //     meta: {requireAuth: true, roles: [SA]},
            //     component: () => import(/* webpackChunkName: "admin-shopping" */ '@/views/spoAdmin/shopping/orderDetail/order.vue'),
            //     redirect: '/spoAdmin/shopping/order/list',
            //     children: [
            //         {
            //             path: '/spoAdmin/shopping/order/list',
            //             meta: {requireAuth: true, roles: [SA]},
            //             component: () => import(/* webpackChunkName: "admin-shopping" */ '@/views/spoAdmin/shopping/orderDetail/orderList.vue'),
            //         },
            //         {
            //             path: '/spoAdmin/shopping/order/setting',
            //             meta: {requireAuth: true, roles: [SA]},
            //             component: () => import(/* webpackChunkName: "admin-shopping" */ '@/views/spoAdmin/shopping/orderDetail/orderSetting.vue'),
            //         },
            //         {
            //             path: '/spoAdmin/shopping/order/refund',
            //             meta: {requireAuth: true, roles: [SA]},
            //             component: () => import(/* webpackChunkName: "admin-shopping" */ '@/views/spoAdmin/shopping/orderDetail/refundOrderList.vue'),
            //         },
            //         {
            //             path: '/spoAdmin/shopping/order/refundReasons',
            //             meta: {requireAuth: true, roles: [SA]},
            //             component: () => import(/* webpackChunkName: "admin-shopping" */ '@/views/spoAdmin/shopping/orderDetail/refundReasons.vue'),
            //         },
            //     ]
            // },
            {
                path: '/spoAdmin/systemSetting',
                meta: {requireAuth: true, roles: []},
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                props: (route) => ({currentTab: 'systemSetting'}),
                redirect: '/spoAdmin/systemSetting/languageSettings',
                children: [
                    // {
                    //     path: '/spoAdmin/systemSetting/fontSettings',
                    //     meta: {requireAuth: true, roles: []},
                    //     component: () => import('@/views/spoAdmin/systemSetting/fontSettings.vue'),
                    // },
                    {
                        path: '/spoAdmin/systemSetting/languageSettings',
                        meta: {requireAuth: true, roles: []},
                        component: () => import('@/views/spoAdmin/systemSetting/languageSettings.vue'),
                    }
                ]
            },
            {
                path: "/spoAdmin/power",
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                props: (route) => ({currentTab: 'power'}),
                redirect: '/spoAdmin/power/data',
                children: [{
                    path: '/spoAdmin/power/data',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/power/main.vue'),
                    props: (route) => ({plantNumber: route.query.plantNumber, monitorId: route.query.monitorId}),
                }, {
                    path: '/spoAdmin/power/statistics',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/power/statistics.vue'),
                }]
            },
            {
                path: "/spoAdmin/layout",
                component: () => import('@/views/spoAdmin/data/layout/main.vue'),
                meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                props: (route) => ({plantNumber: route.query.plantNumber}),
                redirect: '/spoAdmin/layout/layout2D',
                children: [
                    {
                        path: '/spoAdmin/layout/layout2D',
                        meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                        component: () => import('@/views/spoAdmin/data/layout/layout2D.vue'),
                    }, {
                        path: '/spoAdmin/layout/layout3D',
                        meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                        component: () => import('@/views/spoAdmin/data/layout/layout3D.vue'),
                    }, {
                        path: '/spoAdmin/layout/layoutSet',
                        meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                        component: () => import('@/views/spoAdmin/data/layout/layoutSet.vue'),
                    }, {
                        path: '/spoAdmin/layout/layoutStatic',
                        meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                        component: () => import('@/views/spoAdmin/data/layout/layoutStatic.vue'),
                    }
                ]
            }, {
                path: "/spoAdmin/plant",
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                props: (route) => ({currentTab: 'plant'}),
                redirect: '/spoAdmin/plant/plantList',
                children: [{
                    path: '/spoAdmin/plant/plantList',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/plant/plantList.vue'),
                    props: (route) => ({plantNumber: route.query.plantNumber}),
                }, {
                    path: '/spoAdmin/plant/image',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/plant/images.vue'),
                    props: (route) => ({flag: 'plant', id: route.query.id}),
                }, {
                    path: '/spoAdmin/plant/moduleList',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/plant/moduleList.vue'),
                    props: (route) => ({plantNumber: route.query.plantNumber}),
                }, {
                    path: '/spoAdmin/plant/plantLog',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/plant/plantLog.vue'),
                    props: (route) => ({plantNumber: route.query.plantNumber}),
                }, {
                    path: '/spoAdmin/plant/plantWorkLog',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/plant/plantWorkLog.vue'),
                    props: (route) => ({plantNumber: route.query.plantNumber}),
                }]
            }, {
                path: "/spoAdmin/fault",
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                props: (route) => ({currentTab: 'fault'}),
                redirect: '/spoAdmin/fault/faultList',
                children: [{
                    path: '/spoAdmin/fault/faultList',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/fault/faultList.vue'),
                }]
            }, {
                path: "/spoAdmin/module",
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                props: (route) => ({currentTab: 'module'}),
                redirect: '/spoAdmin/module/moduleList',
                children: [{
                    path: '/spoAdmin/module/moduleList',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/module/moduleList.vue'),
                    props: (route) => ({userName: route.query.userName}),
                }, {
                    path: '/spoAdmin/module/moduleSharing',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/module/sharingList.vue'),
                    props: (route) => ({userName: route.query.userName}),
                }, {
                    path: '/spoAdmin/module/monitorChanged',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/module/monitorChanged.vue'),
                    props: (route) => ({moduleId: route.query.moduleId}),
                }, {
                    path: '/spoAdmin/module/moduleLog',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/module/moduleLog.vue'),
                    props: (route) => ({moduleId: route.query.moduleId}),
                }, {
                    path: '/spoAdmin/module/moduleWorkLog',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/module/moduleWorkLog.vue'),
                    props: (route) => ({moduleId: route.query.moduleId}),
                }, {
                    path: '/spoAdmin/module/moduleTypeList',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/module/moduleTypeList.vue'),
                    props: (route) => ({moduleType: route.query.moduleType}),
                }, {
                    path: '/spoAdmin/module/moduleSpecification',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/module/moduleSpecification.vue'),
                    props: (route) => ({moduleType: route.query.moduleType}),
                }, {
                    path: '/spoAdmin/module/monitorSpecification',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/module/monitorSpecification.vue'),
                    props: (route) => ({monitorType: route.query.monitorType}),
                }, {
                    path: '/spoAdmin/module/powerGrid',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/module/powerGrid.vue'),
                }, {
                    path: '/spoAdmin/module/image',
                    meta: {requireAuth: true, roles: [SA, AD, AP, AS, AF, AO, FT]},
                    component: () => import('@/views/spoAdmin/data/plant/images.vue'),
                    props: (route) => ({flag: 'moduleType', id: route.query.id}),
                }]
            },
            {
                path: "/spoAdmin/pointsManagement",
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                meta: {requireAuth: true, roles: []},
                props: (route) => ({currentTab: 'redeemOrder'}),
                redirect: '/spoAdmin/pointsManagement/redeemOrder',
                children: [
                    {
                        path: '/spoAdmin/pointsManagement/redeemOrder',
                        component: () => import('@/views/spoAdmin/pointsManagement/redeemOrder.vue'),
                        meta: {requireAuth: true, roles: []},
                        props: (route) => ({user: route.query.user}),
                    },
                ]
            },
            {
                path: "/spoAdmin/pointsManagement",
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                meta: {requireAuth: true, roles: []},
                props: (route) => ({currentTab: 'productList'}),
                redirect: '/spoAdmin/pointsManagement/productList',
                children: [
                    {
                        path: '/spoAdmin/pointsManagement/productList',
                        component: () => import('@/views/spoAdmin/pointsManagement/productList.vue'),
                        meta: {requireAuth: true, roles: []},
                    },
                ]
            },
            {
                path: "/spoAdmin/networkCard",
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                meta: {requireAuth: true, roles: []},
                props: (route) => ({currentTab: 'networkCard'}),
                redirect: '/spoAdmin/networkCard/card',
                children: [
                    {
                        path: '/spoAdmin/networkCard/card',
                        component: () => import('@/views/spoAdmin/networkCard/card.vue'),
                        meta: {requireAuth: true, roles: []},
                        props: (route) => ({user: route.query.user}),
                    },
                    {
                        path: '/spoAdmin/networkCard/trafficPool',
                        component: () => import('@/views/spoAdmin/networkCard/trafficPool.vue'),
                        meta: {requireAuth: true, roles: []},
                        props: (route) => ({user: route.query.user}),
                    },
                    {
                        path: '/spoAdmin/networkCard/plan',
                        component: () => import('@/views/spoAdmin/networkCard/plan.vue'),
                        meta: {requireAuth: true, roles: []},
                        props: (route) => ({user: route.query.user}),
                    }
                ]
            },
            {
                path: "/spoAdmin/networkCard",
                component: () => import('@/views/spoAdmin/subTabs.vue'),
                meta: {requireAuth: true, roles: []},
                props: (route) => ({currentTab: 'networkCardOrder'}),
                redirect: '/spoAdmin/networkCard/order',
                children: [
                    {
                        path: '/spoAdmin/networkCard/order',
                        component: () => import('@/views/spoAdmin/networkCard/order.vue'),
                        meta: {requireAuth: true, roles: []},
                        props: (route) => ({user: route.query.user}),
                    },
                ]
            }
        ]
    }
];